<div [class.p-4]="!dialogRef">
  <h4 mat-dialog-title>
    <span *ngIf="!polizza; else editHeader"> Creazione nuova polizza </span>
    <ng-template #editHeader>
      Modifica polizza {{ polizza.humanIdentifier }}
    </ng-template>
  </h4>

  <form
    class="mt-4 row"
    *ngIf="form; else loader"
    [formGroup]="form"
    (keydown.enter)="handleSuccessfulSubmit()"
  >
    <mat-form-field>
      <mat-label>Numero</mat-label>
      <input matInput formControlName="numero" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Compagnia</mat-label>
      <compagnia-picker formControlName="compagnia"></compagnia-picker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Sottocompagnia</mat-label>
      <input matInput formControlName="sottocompagnia" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Agenzia</mat-label>
      <agenzia-picker
        [defaultSearch]="{ compagnia: form?.value?.compagnia }"
        formControlName="agenzia"
      >
      </agenzia-picker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Contraente</mat-label>
      <contraente-picker
        type="contraente"
        formControlName="contraente"
      ></contraente-picker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Data Decorrenza</mat-label>
      <date-picker matInput formControlName="data_decorrenza"></date-picker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>CGA</mat-label>
      <cga-picker
        displayField="nome_condizione"
        formControlName="cga"
      ></cga-picker>
    </mat-form-field>

    <mat-form-field *ngIf="shouldShowFabbricatoField()">
      <mat-label>Fabbricato</mat-label>
      <fabbricato-picker formControlName="fabbricato"></fabbricato-picker>
    </mat-form-field>

    <div
      class="mat-form-field mb-3"
      *ngIf="shouldShowAddFabbricatoButton()"
      matTooltip="Aggiunge un fabbricato con campi di default e lo assegna al campo 'fabbricato' di questa polizza"
    >
      <button
        mat-raised-button
        color="primary"
        (click)="aggiungiFabbricatoDelContraente()"
      >
        Aggiungi fabbricato del contraente
      </button>
    </div>
  </form>
  <button mat-raised-button (click)="handleSuccessfulSubmit()" color="primary">
    Salva
  </button>
  <ng-template #loader>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>
